const isFormFieldEmpty = (value) => value === "" || value === null || value === undefined;

export const isSubmitDisabled = (values) => {
  const requiredFields = ["model", "site", "building", "floor", "room", "group"];
  return requiredFields.some((field) => isFormFieldEmpty(values?.[field]));
};

export const sortByKeyAlpha = (arr, key) => {
  return [...(arr || [])].sort((a, b) => {
    const valA = (a?.[key] || "").toString().toLowerCase();
    const valB = (b?.[key] || "").toString().toLowerCase();
    return valA.localeCompare(valB);
  });
};

export const getApproveText = (isEditMode) => (isEditMode ? "Update" : "Assign");

export const getDialogTitle = (isEditMode) =>
  isEditMode ? "Edit assign group to model and location" : "Assign group to model and location";

export const createGroupSelectChangeHandler = ({ sortedGroupList, formik }) => {
  return (e) => {
    let selected = "";
    if (e.detail !== null) {
      selected = sortedGroupList[e.detail];
    }
    if (selected?.groupName !== formik.values.group) {
      formik.setFieldValue("group", selected.groupName, true);
    }
  };
};

export const buildGroupOptionKey = (item, index) => `${item.groupName}-${index}-${item.id || ""}`;
